<template>
  <div class="columns flex-column-reverse-is-mobile">
    <div class="column is-narrow max-width-300px-if-not-mobile">
      <aside class="menu">
        <FolderSection />
        <GroupsSection />
      </aside>
    </div>

    <div class="column" >

      <Uppy v-if="!legacyUploader && mayUploadVideo"/>

      <div class="d-flex align-items-center mb-4 flex-wrap-reverse-if-mobile">
        <div class="d-flex align-items-center w-100">
          <input class="input mt-0 br-0 mr-2"
            type="search"
            v-model="query"
            placeholder="search all videos">
          <a
            @click="rows = true"
            data-balloon="List View"
            data-balloon-pos="down"
            :class="rows && 'is-active'"
            class="d-flex align-items-center if-not-mobile">
            <BarsIcon :fill="rows ? 'black' : '#dbdbdb' " width="25px"/>
          </a>
          <a
            @click="rows = false"
            data-balloon="Grid View"
            data-balloon-pos="down"
            :class="!rows && 'is-active'"
            class="pl-2 d-flex align-items-center mr-2 if-not-mobile">
            <TableIcon :fill="rows ? 'black' : '#dbdbdb' " width="25px"/>
          </a>
        </div>

      <button
        type='button'
        class='button is-info w-100-if-mobile mb-4-if-mobile'
        id="add-video"
        :disabled="!mayUploadVideo"
        name='add video'>
        + Add Video
      </button>
      <GoogleFilePicker v-if="permGoogleDrive"/>
      </div>

      <section>
        <p class="mb-4">
          <span class="text-muted">Filter:</span>
          <a class="filter" :class="{ 'activeFilter': filterBy == 'ALL' }" @click="filterBy = 'ALL'">All Videos</a>
          <span>|</span>
          <a class="filter" :class="{ 'activeFilter': filterBy == 'MY_VIDEOS' }" @click="filterBy = 'MY_VIDEOS'">My Videos</a>
          <span>|</span>
          <a class="filter" :class="{ 'activeFilter': filterBy == 'SHARED_WITH_ME' }" @click="filterBy = 'SHARED_WITH_ME'">Shared with Me</a>
        </p>
        <section class="d-flex justify-content-center w-100 align-items-center" v-if="loading">
          <Loader />
        </section>
        <VideosTable
          :class="rows ? 'rows' : 'grid'"
          :videos="selectedVideos"
          v-else
        />

        <div class="d-flex align-items-center flex-column" v-if="noVideos && !loading">

          <div v-if="mayUploadVideo" class="mt-4">
            <p class="text-muted text-center fs-2rem">You haven't uploaded any videos yet.</p>
            <p class="text-muted text-center fs-1rem">Use the <b>+ Add Video</b> button above.</p>
          </div>

          <div v-if="!mayUploadVideo" class="d-flex align-items-center flex-column">
            <p class="text-muted text-center fs-1rem">
              You must confirm your email address to enable uploading.
            </p>
            <button class="button is-primary mt-1"
                    :class="{'is-loading': loadingResendEmailConfirmation}"
                    @click="resendConfirmationEmail">
                Resend confirmation email
            </button>
          </div>

        </div>
        <div v-else-if="nothingFound && !loading" class="d-flex align-items-center flex-column" >
          <p class="text-muted text-center fs-2rem break-word">
            No videos found matching: <strong>{{ query }}</strong>
          </p>
        </div>

        <div v-if="filterBy === 'SHARED_WITH_ME' && noSharedVideos && !loading" class="mt-4">
          <p class="text-muted text-center fs-2rem">No videos have been shared with you yet.</p>
          <p class="text-muted text-center fs-1rem">
            Try the <b>share</b> button on the video page.
          </p>
        </div>

      </section>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import store from '../store'
import VideoCard from './VideoCard.vue'
import VideosTable from './VideosTable.vue'
import Loader from './Loader.vue'
import Uppy from './Uppy.vue'
import GroupsSection from './GroupsSection.vue'
import TableIcon from './TableIcon.vue'
import BarsIcon from './BarsIcon.vue'
import FolderSection from './FolderSection'
import GoogleFilePicker from './GoogleFilePicker'
import { byCreatedOn } from '../sorters.js'
import { matchesQuery } from '../search'

export default {
  name: 'Videos',
  components: {
    VideoCard,
    Loader,
    VideosTable,
    Uppy,
    GroupsSection,
    BarsIcon,
    TableIcon,
    FolderSection,
    GoogleFilePicker,
  },
  async mounted () {
    await Promise.all([
      store.dispatch('fetchVideos'),
      store.dispatch('fetchVideosSharedWithMe'),
    ])
    this.loading = false
  },
  data () {
    return {
      query: '',
      rows: true,
      loading: true,
      filterBy: 'ALL',
    }
  },
  computed: {
    ...mapGetters([
      'videos'
    ]),
    noVideos () {
      return this.videos.length === 0
    },
    userID () {
      return store.state.user.id
    },
    selectedVideos () {
      const sharedVideosResults = store.state.videosSharedWithMe
        .sort(byCreatedOn)
        .filter(x => matchesQuery(x, this.query))
        .map(x => ({ ...x, shared: true }))

      if (this.filterBy === 'SHARED_WITH_ME') {
        return sharedVideosResults
      }

      const myVideosResults = this.videos
        .sort(byCreatedOn)
        .filter(x => matchesQuery(x, this.query))

      if (this.filterBy === 'MY_VIDEOS') {
        return myVideosResults
      }

      return [...myVideosResults, ...sharedVideosResults].sort(byCreatedOn)
    },
    noSharedVideos () {
      return store.state.videosSharedWithMe.length === 0
    },
    nothingFound () {
      return this.selectedVideos.length === 0 && this.query !== ''
    },
    showAddVideoModal () {
      return store.state.showAddVideoModal
    },
    legacyUploader () {
      return store.state.user.legacy_uploader
    },
    mayUploadVideo () {
      return store.state.user.email_confirmed
    },
    loadingResendEmailConfirmation () {
      return store.state.loadingResendEmailConfirmation
    },
    permGoogleDrive () {
      return store.state.user.perm_google_drive
    }
  },
  methods: {
    resendConfirmationEmail () {
      store.dispatch('resendEmailConfirmation')
    },
  },
}
</script>

<style lang="scss" scoped>
  @import '../_variables.scss';

  .video-section {
    max-height: 800px;
    overflow-y:scroll;
  }

  .add-video {
    height: 10rem;
    display: flex;
    /* flex-grow: 1; */
    width: 30rem;
    color: #23c6c8;
    font-size: 2rem;
    margin-bottom: 1rem;
    margin-top: 0rem;

    border: 2px dashed #23c6c8;
    border-radius: 5px;
    background: white;

    @media screen and (max-width: 500px) {
      font-size: 2rem;
    }
  }

  .tab-border-bottom {
    border-bottom: 1px solid #dbdbdb;
  }

  @media (min-width: $mobile) {
  .grid {
      display: grid;
      grid-gap: 1rem;
      grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    }
  }

  .flex-column-reverse-is-mobile {
    @media (max-width: 769px) {
      display: flex;
      flex-direction: column-reverse;
    }
  }

  .filter {
    transition: all .1s;
    font-weight: 500;
  }

  .activeFilter {
    color: #363636;
  }
</style>



// WEBPACK FOOTER //
// Videos.vue?709bbf42